async function getLidarConfigurationTypes () {
    return this.api({
        url: `/cars/scc/types/lidar-configuration`,
        method: 'GET'
    })
}

async function getSccStation ( stationId ) {
    return this.api({
        url: `/cars/scc/station/${stationId}`,
        method: 'GET'
    })
}

async function getSccStationLidars ( stationId ) {
    return this.api({
        url: `/cars/scc/station/${stationId}/lidars`,
        method: 'GET'
    })
}

async function getLidarVersions ( lidarId ) {
    return this.api({
        url: `/cars/scc/lidar/${lidarId}/versions`,
        method: 'GET'
    })
}

async function getLidarConfigurations ( lidarId ) {
    return this.api({
        url: `/cars/scc/lidar/${lidarId}/configurations`,
        method: 'GET'
    })
}

async function getConfiguration ( configurationId ) {
    return this.api({
        url: `/cars/scc/configuration/${configurationId}`,
        method: 'GET'
    })
}

async function getConfigurationData ( configurationId ) {
    return this.api({
        url: `/cars/scc/configuration/${configurationId}/data`,
        method: 'GET'
    })
}

export default {
    pluginName: 'scc',
    methods: {
        getLidarConfigurationTypes,
        getSccStation, getSccStationLidars,
        getLidarVersions, getLidarConfigurations,
        getConfiguration, getConfigurationData
    }
}